@if (showLabel()) {
  <div class="fx--h fx--label fx--label__nowrap fx--mb-4 fx--label__bold fx--juc-space-between">
    <label class="miq-form-input-label" [attr.for]="filter$().key">{{ filter$().value }}</label>
  </div>
}
@switch (filter$().inputType) {
  @case ('date') {
    <mat-form-field appearance="outline">
      <input
        matInput
        [formControl]="control"
        [attr.aria-label]="filter$().value"
        [placeholder]="filter$().placeholder"
        [disabled]="control.disabled"
        [matDatepicker]="equalDatePicker"
        autocomplete="no-autofill"
        />
        <mat-datepicker-toggle matSuffix [for]="equalDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #equalDatePicker></mat-datepicker>
      </mat-form-field>
    }
    @case ('dropdown') {
      <ng-container class="flex-form">
        <p-dropdown
          class="primeng-dropdown equal-item-dp"
          [formControl]="control"
          [attr.aria-label]="filter$().value"
          [placeholder]="filter$().placeholder"
          [options]="options"
          [appendTo]="'body'"
          [showClear]="hasClearIcon"
          (onChange)="handleChange()"
          >
          <!-- Clear icon-->
          <ng-template pTemplate="clearicon">
            <em class="multiselect-clear pi pi-times-circle" (click)="control.setValue(null)"></em>
          </ng-template>
        </p-dropdown>
      </ng-container>
    }
    @default {
      <mat-form-field appearance="outline">
        <input
          matInput
          [id]="filter$().key"
          [formControl]="control"
          [type]="filter$().inputType"
          [readonly]="control?.disabled"
          [attr.aria-label]="filter$().value"
          [placeholder]="filter$().placeholder"
          autocomplete="no-autofill"
          (keydown.enter)="handleChange()"
          />
        </mat-form-field>
      }
    }
